//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FileUpload from './file-upload'

export default {
  components: {
    FileUpload
  },
  data: () => ({
    files: [],
    headers: {},
    data: {},
    postAction: '/server/community/public/common/upload',
    extensions: 'gif,jpg,jpeg,png,webp',
    accept: 'image/*',
    multiple: true,
    drop: false,
    dropDirectory: false,
    size: 1024 * 1024 * 10,
    thread: 9,
    automatic: true,
    maxLength: 9,
    preload: true
  }),
  methods: {
    previewImage (file) {
      if (window.WeixinJSBridge) {
        window.WeixinJSBridge.invoke('imagePreview', {
          'urls': this.files.map(file => {
            return file.response.data ? file.response.data[0].filename + '_large' : undefined
          }),
          'current': file.response.data ? file.response.data[0].filename + '_large' : false
        })
      }
    },

    inputFilter (newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // 添加文件前
        // Filter system files or hide files
        // 过滤系统文件 和隐藏文件
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent()
        }

        // Filter php html js file
        // 过滤 php html js 文件
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent()
        }
      }

      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        // Create a blob field
        // 创建 blob 字段
        newFile.blob = ''
        let URL = window.URL || window.webkitURL
        if (URL && URL.createObjectURL) {
          newFile.blob = URL.createObjectURL(newFile.file)
        }

        // Thumbnails
        // 缩略图
        newFile.thumb = ''
        if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
          newFile.thumb = newFile.blob
        }
      }
    },

    inputFile (newFile, oldFile) {
      if (newFile && !oldFile) {
        // add
        // console.log('add', newFile)
      }
      if (newFile && oldFile) {
        // update
        // console.log('update', newFile)

        if (newFile.active && !oldFile.active) {
          // beforeSend

          // min size
          if (newFile.size >= 0 && this.minSize > 0 && newFile.size < this.minSize) {
            this.$refs.upload.update(newFile, { error: 'size' })
          }
        }

        if (newFile.progress !== oldFile.progress) {
          // progress
        }

        if (newFile.error && !oldFile.error) {
          // error
        }

        if (newFile.success && !oldFile.success) {
          // success
          // console.log('success', newFile.response.data)
          this.emitInput()
        }

        // Uploaded successfully
        if (newFile.success !== oldFile.success) {
        }
      }

      if (!newFile && oldFile) {
        // remove
        this.emitInput()
      }

      // Automatic upload
      if (this.automatic) {
        if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
          if (!this.$refs.upload.active) {
            this.$refs.upload.active = true
          }
        }
      }
    },
    // 绑定返回的数据
    emitInput () {
      let rel = []
      rel = this.files.map(file => {
        return file.response.data ? file.response.data[0].filename : undefined
      })
      this.$emit('input', rel)
    },

    // 清空数据
    clear () {
      this.$refs.upload.clear()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/upload/album.vue